// GTM dataLayer event helpers for the new Mazda homepage (DLK-729).
// Thin wrappers over window.dataLayer.push so the analytics team receives the
// exact event names and params from the spec. window.dataLayer is typed in
// typings/global.d.ts. Event-name spelling is verbatim from the spec
// (including "carousell").

type DataLayerEvent = { event: string } & Record<string, unknown>

const pushToDataLayer = (payload: DataLayerEvent): void => {
  if (typeof window === "undefined") return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(payload)
}

/** CTA click in the main hero banner. click_name = clicked button label. */
export const trackHeroBannerCtaClick = (clickName: string): void =>
  pushToDataLayer({ event: "cta_banner_clicks_homepage", click_name: clickName })

/** CTA click in the actions section below the hero. click_name = clicked card label. */
export const trackActionsCtaClick = (clickName: string): void =>
  pushToDataLayer({ event: "cta_actions_clicks_homepage", click_name: clickName })

/** Model click in the homepage models carousel. click_name = model name. */
export const trackModelsCarouselClick = (clickName: string): void =>
  pushToDataLayer({
    event: "models_carousell_clicks_homepage",
    click_name: clickName,
  })

/** Article/story click on the homepage. article_name = article title. */
export const trackArticleClick = (articleName: string): void =>
  pushToDataLayer({ event: "article_clicks_homepage", article_name: articleName })

/** Fires only on a confirmed successful newsletter signup. No params. */
export const trackNewsletterSignup = (): void =>
  pushToDataLayer({ event: "newsletter_signups" })
